import React from "react";
import workDeal from "../../Assets/work-deal.webp";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { Reveal } from "../Reveal/Reveal";
import "./style.css";

export const WhyChooseDataDept = () => {
  return (
    <section className="about-page-section-3 container-style">
      <div className="content-sizing about-page-section-3-wrapper">
        <img
          src={workDeal}
          className="work-deal-image-about"
          loading="lazy"
          alt="Work Deal"
        />
        <Reveal delay={0.2}>
          <div className="why-serivce-about">
            <h2>Why our services are better than others?</h2>
            <p>
              Our expert team crafts top-tier solutions, prioritizing your
              vision to exceed expectations. Embracing innovation and
              collaboration, we're committed to delivering competitive,
              cutting-edge results.
            </p>
            <p>
              Emphasizing collaboration and transparency, we commit to
              excellence at every step, ensuring our solutions not only solve
              challenges but also secure a competitive edge in your industry.
            </p>
            <ul>
              <li>
                <IoIosCheckmarkCircle /> <h2>Expertise and Experience</h2>
              </li>
              <li>
                <IoIosCheckmarkCircle /> <h2>Innovation and Quality</h2>
              </li>
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
